export default __webpack_public_path__ + "static/media/csv.06a72502.svg";